import React from 'react';
import Icon from '../../../components/AppIcon';

const StatisticsCards = ({ stats }) => {
  const cards = [
    {
      label: 'Total Prompts Generated',
      value: stats?.totalPrompts || 0,
      icon: 'FileText',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      description: 'All time'
    },
    {
      label: 'This Week',
      value: stats?.thisWeek || 0,
      icon: 'TrendingUp',
      color: 'text-success',
      bgColor: 'bg-success/10',
      description: 'Last 7 days'
    },
    {
      label: 'Today',
      value: stats?.today || 0,
      icon: 'Zap',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      description: 'Current day'
    },
    {
      label: 'Most Popular Tool',
      value: stats?.mostPopularTool || 'N/A',
      icon: 'Award',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      description: 'Top AI tool'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {cards?.map((card, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-shadow"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`${card?.bgColor} rounded-lg p-3`}>
              <Icon name={card?.icon} size={24} className={card?.color} />
            </div>
          </div>
          <h3 className="text-2xl font-bold text-foreground mb-1">{card?.value}</h3>
          <p className="text-sm font-medium text-foreground mb-1">{card?.label}</p>
          <p className="text-xs text-muted-foreground">{card?.description}</p>
        </div>
      ))}
    </div>
  );
};

export default StatisticsCards;